import { config } from './config/config';
import { constants } from './config/constants';

const { dataReceived } = require('./EnquiryHandler')
const { setIntentName, getIntentName, getButtonName, setButtonName, setIntentTicket, getIntentTicket, setCurrentFlow, getCurrentFlow, getNumber, setNumber, getIntentValue, setIntentValue, setIsOTPValidated, getAWBValue, setIsOtpSent, setRegisteredNo, getShipmentStatus, getAttemptCount, getEDD, getShipmentType, getBusinessType, getPddBreach, setPddBreach, getDDT, getClientName, getReattemptDate, getNDR, getNDRDate, getWHHandOver, getAddressPincode, setAddressPincode, setAddressUpdateStep, getOtpAttempts, setOtpAttempts, resetOtpAttempts, getLatestShipmentStatus } = require('../components/SessionStorage');
const { fetchHeaders, createPayload, createOtpSendPayload, createOTPPayload, createIntentPayload, createStatusPayload, createRequestPayload, createTicketPayload, createAwbDetailsPayload, createDelayPayload, createAddressUpdatePayload, createRiderConcernPayload} = require('../js/payloads')

const fetchRecordsPrompt = constants.prompt_of_fetch_records;
const fetchRecordsOtpPrompt = constants.prompt_of_fetch_records_otp;
const statusButtons = constants.status_buttons;
const OTP_MAX_ATTEMPTS = constants.OTP_MAX_ATTEMPTS || 3;
// #enhancements_pxb5559 changes done according workflow enhancements
const rvpButtons = constants.rvp_buttons;
const fwdButtons = constants.fwd_buttons;
const DELIVERY_DATE_ENQUIRY = constants.DELIVERY_DATE_ENQUIRY;
const FUTURE_DATE_DELIVERY = constants.FUTURE_DATE_DELIVERY;
const RESCHEDULE_SHIPMENT = constants.RESCHEDULE_SHIPMENT;
const RESCHEDULE_PICKUP = constants.RESCHEDULE_PICKUP;
const SELF_COLLECT = constants.SELF_COLLECT;
const SELF_COLLECT_SHIPMENT = constants.SELF_COLLECT_SHIPMENT;
const FUTURE_PICKUP_DATE = constants.FUTURE_PICKUP_DATE;
const UPDATE_ALTERNATE_CONTACT = constants.UPDATE_ALTERNATE_CONTACT;
const SHIPMENT_NOT_RECEIVED = constants.SHIPMENT_NOT_RECEIVED;
const MISBEHAVIOR_BY_SR = constants.MISBEHAVIOR_BY_SR;
const CHARGED_EXTRA_AMOUNT = constants.CHARGED_EXTRA_AMOUNT;
const WRONG_PRODUCT_PICKED = constants.WRONG_PRODUCT_PICKED;
const PRODUCT_NOT_PICKED = constants.PRODUCT_NOT_PICKED;
const PRODUCT_DAMAGED = constants.PRODUCT_DAMAGED;
const PRODUCT_MISSING = constants.PRODUCT_MISSING;
const HOME_BUTTONS = constants.home_buttons;
const MIS_DAM_PRODUCT = constants.MIS_DAM_PRODUCT;
const NDR_CWFD_CALL_LOG = constants.NDR_CWFD_CALL_LOG;
const NDR_CRA_CALL_LOG = constants.NDR_CRA_CALL_LOG;
const NDR_ADI_CALL_LOG = constants.NDR_ADI_CALL_LOG;
const NPR_HANDED_CALL_LOG = constants.NPR_HANDED_CALL_LOG;
const NPR_ADI_CALL_LOG = constants.NPR_ADI_CALL_LOG;
const NPR_CWFP_CALL_LOG = constants.NPR_CWFP_CALL_LOG;
const RPCANCEL_PICKUP_CALL_LOG = constants.RPCANCEL_PICKUP_CALL_LOG;
const RPCANCEL_REFUND_DATE_SELECTION = constants.RPCANCEL_REFUND_DATE_SELECTION;
const NDR_PNC_DATE_SELECTION = constants.NDR_PNC_DATE_SELECTION;
const NDR_PNC_REATTEMPT_DELAY = constants.NDR_PNC_REATTEMPT_DELAY;
const NDR_CWFD_REATTEMPT_DELAY = constants.NDR_CWFD_REATTEMPT_DELAY;
const NDR_CRA_REATTEMPT_DELAY = constants.NDR_CRA_REATTEMPT_DELAY;
const NDR_ADI_REATTEMPT_DELAY = constants.NDR_ADI_REATTEMPT_DELAY;
const NPR_CWFP_REATTEMPT = constants.NPR_CWFP_REATTEMPT;
const CWFP_REATTEMPT_TICKET_CREATED_KEY = 'cwfp-reattempt-ticket-created';
const WHERE_IS_MY_SHIPMENT = constants.WHERE_IS_MY_SHIPMENT;
const CUSTOMER_CARE_NUMBER = constants.CUSTOMER_CARE_NUMBER;
const CUSTOMER_CARE_CLICKABLE = constants.CUSTOMER_CARE_CLICKABLE;
const DELIVERED_INCORRECT_SHIPMENT_FLOW = constants.DELIVERED_INCORRECT_SHIPMENT_FLOW;

export const fetchHomeButtonsOptions = async () => {
    try {
        const payload = await createPayload("Home1", fetchRecordsPrompt);
        const response = await fetch(config.chatbotbackendapi, await fetchHeaders(payload));
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        let result = await response.json();
        if (result && result.response && result.response.length > 0) {
            if (result.response[0].buttons) {
                return result.response[0].buttons;
            } else if (result.response[0].text) {
                return [];
            }
        }
        return [];
    } catch (error) {
        console.error('Error sending webhook data:', error);
        return [];
    }
};

export async function fetchOptionsOfInput(input, flag){
    try {
        if (flag) {
            setButtonName(input);
            await fetchIntentOfInput(input, false);
        }
        const payload = await createPayload(input, fetchRecordsPrompt);
        const response = await fetch(config.chatbotbackendapi, await fetchHeaders(payload));
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        let result = await response.json();
        if (result && result.response && result.response.length > 0) {
            // Check all response items for buttons (not just index 0)
            for (let i = 0; i < result.response.length; i++) {
                if (result.response[i].buttons) {
                    // If there's a preceding text message, return the full response array
                    // so insertMessages can render both text and buttons
                    if (i > 0 && result.response[0].text) {
                        return result.response;
                    }
                    return result.response[i].buttons;
                }
            }
            if (result.response[0].text) {
                return [];
            }
        }
        return [];
    } catch (error) {
        console.error('Error sending webhook data:', error);
        return [];
    }
};

export async function fetchFeedbackOptions() {
    try {
        const payload = await createPayload('Was this helpful?', fetchRecordsPrompt);
        const response = await fetch(config.chatbotbackendapi, await fetchHeaders(payload));
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        let result = await response.json();
        if (result && result.response && result.response.length > 0) {
            return result.response;
        }
        return null;
    } catch (error) {
        console.error('Error fetching feedback options:', error);
        return null;
    }
}

export const sendOTPFunction = async (mobileNo) => {
    try {
        const { normalizeMobileInput } = require('../js/payloads');
        const normalizedMobile = normalizeMobileInput(mobileNo);
        if (!/^\d{10}$/.test(normalizedMobile)) {
            console.error('Invalid mobile number for OTP:', mobileNo);
            return { success: false, message: constants.INVALID_MOBILE_MESSAGE };
        }
        setNumber(normalizedMobile);
        resetOtpAttempts();
        const payload = await createOtpSendPayload(normalizedMobile);
        const response = await fetch(config.chatbotbackendapi, await fetchHeaders(payload));
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const result = await response.json();
        const responseText = String(result?.response?.[0]?.text || '');
        const responseTextLower = responseText.toLowerCase();
        if (
            responseTextLower.includes('unable to send otp')
            || responseTextLower.includes('error occurred')
            || responseTextLower.includes('entered mobile number is incorrect')
            || responseTextLower.includes('mobile number not provided')
        ) {
            setIsOtpSent(false);
            return {
                success: false,
                message: responseTextLower.includes('entered mobile number is incorrect')
                    ? constants.INVALID_MOBILE_MESSAGE
                    : (responseText || constants.INVALID_MOBILE_MESSAGE),
            };
        }
        setIsOtpSent(true);
        return { success: true };
    } catch (error) {
        console.error('Error sending webhook data:', error);
        setIsOtpSent(false);
        return { success: false, message: 'Unable to send OTP right now. Please try again later.' };
    }
};

export const recordOtpFailure = () => {
    const nextAttempts = getOtpAttempts() + 1;
    if (nextAttempts >= OTP_MAX_ATTEMPTS) {
        resetOtpAttempts();
        setIsOtpSent(false);
        return 'OTP-LOCKED';
    }
    setOtpAttempts(nextAttempts);
    return 'OTP-FAILED';
};

export const validateOTPFunction = async(otp) => {
    try {
        // Client-side attempt guard before hitting the server
        const attempts = getOtpAttempts();
        if (attempts >= OTP_MAX_ATTEMPTS) {
            resetOtpAttempts();
            setIsOtpSent(false);
            return "OTP-LOCKED";
        }

        const sentNumber = getNumber();
        const payload = await createOTPPayload(otp, sentNumber);
        const response = await fetch(config.chatbotbackendapi, await fetchHeaders(payload));
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        let result = await response.json();

        if (result && result.response && result.response.length > 0) {
            let msg = result.response[0].text;
            setIsOTPValidated(false);
            if (String(msg || '').toLowerCase().includes('entered mobile number is incorrect')) {
                setIsOtpSent(false);
                resetOtpAttempts();
                return { status: 'MOBILE-INVALID', message: constants.INVALID_MOBILE_MESSAGE };
            }
            if (msg === "OTP verified successfully") {
                setIsOTPValidated(true);
                setIsOtpSent(false);
                resetOtpAttempts();
                // Check if status payload is present (enquiry buttons or rpcancel snapshot-only).
                const buttonsObj = result.response.find(
                    (r) => Array.isArray(r.buttons) || r.latestStatus || r.shipmentSnapshot
                );
                if (buttonsObj) {
                    const statusExtras = result.response.slice(1);
                    const hasSelectableButtons = statusExtras.some((item) => {
                        if (!item || typeof item !== 'object') {
                            return false;
                        }
                        if (Array.isArray(item.buttons)) {
                            return item.buttons.some(
                                (btn) => btn && (btn.type || 'button') !== 'text'
                                    && (btn.content ?? btn.context ?? btn.key ?? btn.text ?? '')
                            );
                        }
                        return item.type === 'button'
                            || Boolean(item.content ?? item.context ?? item.key ?? item.text ?? '');
                    });
                    return {
                        status: "OTP-SUCCESS",
                        buttons: hasSelectableButtons ? statusExtras : [],
                        latestStatus: buttonsObj.latestStatus || '',
                        pdd: buttonsObj.pdd || '',
                        pddBreach: buttonsObj.pddBreach || 'false',
                        shipmentSnapshot: buttonsObj.shipmentSnapshot || null,
                        lastModifiedDate: buttonsObj.lastModifiedDate || '',
                    };
                }
                return "OTP-SUCCESS";           
             } else if (msg === "OTP has expired") {
                resetOtpAttempts();
                return "OTP-EXPIRED";
            } else if (msg.startsWith("Too many failed attempts")) {
                resetOtpAttempts();
                setIsOtpSent(false);
                return "OTP-LOCKED";
            } else if (
                msg.startsWith("Invalid OTP")
                || /no otp found/i.test(String(msg || ''))
            ) {
                return recordOtpFailure();
            } else {
                return "OTP-NO";
            }
        }
        return "OTP-NO";
    } catch (error) {
        return "OTP-NO";
    }
}

const ALT_MOBILE_OTP_PURPOSE = 'alternate_mobile';

export const sendAlternateMobileOtp = async (mobileNo) => {
    try {
        const { normalizeMobileInput } = require('../js/payloads');
        const normalizedMobile = normalizeMobileInput(mobileNo);
        if (!/^\d{10}$/.test(normalizedMobile)) {
            return { success: false };
        }
        const payload = await createOtpSendPayload(normalizedMobile, { otpPurpose: ALT_MOBILE_OTP_PURPOSE });
        const response = await fetch(config.chatbotbackendapi, await fetchHeaders(payload));
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const result = await response.json();
        const responseText = String(result?.response?.[0]?.text || '').toLowerCase();
        if (
            responseText.includes('unable to send otp')
            || responseText.includes('error occurred')
            || responseText.includes('entered mobile number is incorrect')
            || responseText.includes('mobile number not provided')
        ) {
            return { success: false };
        }
        return { success: true };
    } catch (error) {
        console.error('Error sending alternate mobile OTP:', error);
        return { success: false };
    }
};

export const validateAlternateMobileOtp = async (otp, mobileNo) => {
    try {
        const { normalizeMobileInput } = require('../js/payloads');
        const normalizedMobile = normalizeMobileInput(mobileNo);
        const payload = await createOTPPayload(otp, normalizedMobile, { otpPurpose: ALT_MOBILE_OTP_PURPOSE });
        const response = await fetch(config.chatbotbackendapi, await fetchHeaders(payload));
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const result = await response.json();
        const msg = String(result?.response?.[0]?.text || '');
        if (msg === 'Alternate mobile OTP verified') {
            return 'ALT-MOBILE-OTP-SUCCESS';
        }
        if (msg === 'OTP has expired' || msg.startsWith('Too many failed attempts')) {
            return msg;
        }
        return 'ALT-MOBILE-OTP-FAILED';
    } catch (error) {
        console.error('Error validating alternate mobile OTP:', error);
        return 'ALT-MOBILE-OTP-FAILED';
    }
}

const snapshotNeedsNdrReasonRefresh = (snapshot) => {
    if (!snapshot?.poid) {
        return true;
    }
    const latestStatus = String(snapshot.latestStatus || snapshot.LatestStatus || '').toLowerCase();
    if (latestStatus !== 'ndr') {
        return false;
    }
    const lastNdr = snapshot.lastNDR || snapshot.LastNDR
        || snapshot.lastNDRUserProcess || snapshot.LastNDRUserProcess;
    const processCode = snapshot.processCode || snapshot.ProcessCode;
    const reasonCode = snapshot.reasonCode || snapshot.ReasonCode;
    return !lastNdr && !processCode && !reasonCode;
};

export const hydrateForwardNdrShipmentContext = async (shippingId) => {
    const { getNdrShipmentSnapshot } = require('../components/SessionStorage');
    const existing = getNdrShipmentSnapshot();
    if (existing?.poid && !snapshotNeedsNdrReasonRefresh(existing)) {
        return existing;
    }
    const awb = shippingId || getAWBValue();
    if (!awb) {
        return null;
    }
    await fetchIntentOfInput(awb, true);
    return getNdrShipmentSnapshot();
};

export const fetchIntentsFromStorage = async (shippingId) => {
    let data = {
        'intent_name' : getIntentName() ? getIntentName() : "order-status",
        'intent_ticket' : getIntentTicket() ? getIntentTicket() : "order-status-ticket",
        'type' : getCurrentFlow() ?  getCurrentFlow() : "default"
    };
    let mobileNo = shippingId ? shippingId : getAWBValue() ? getAWBValue() : getNumber();
    let resp = await fetchIntentsResponse(data, mobileNo);
    return resp;
}

export const fetchIntentsResponse = async (data, shippingId) => {
    try {
        setIntentName(data['intent_name']);
        setCurrentFlow(data['type']);
        if (data['intent_name']) {
            setIntentTicket(data['intent_ticket']);
            const payload = await createStatusPayload(shippingId, data['intent_name'] );
            const response = await fetch(config.chatbotbackendapi, await fetchHeaders(payload));
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            let result = await response.json();
            // console.log('result -->>', result);
            const message = await dataReceived(result);
            await maybeCreateCwfpReattemptTicket(shippingId);
            return message;
        } else {
            return [];
        }
    } catch (error) {
        console.error('Error sending fetchIntentOfInput:', error);
        return [];
    }
}

export const fetchIntentOfInput = async (shippingId, flag) => {
    try {
        // #features_pxb5559 added additional checking
        shippingId = shippingId ? shippingId : getAWBValue();
        const currentButtonValue = getButtonName();
        const currentFlow = getCurrentFlow();
        if (currentButtonValue) {
            const payload = await createIntentPayload(currentButtonValue, 'fetch-intents');
            const response = await fetch(config.chatbotbackendapi, await fetchHeaders(payload));
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            let result = await response.json();
            if (result && result.response && result.response.length > 0) {
                if (result.response[0].intents) {
                    let data = result.response[0].intents
                    if (flag)
                        return await fetchIntentsResponse(data, shippingId);
                    setIntentName(data['intent_name']);
                    setCurrentFlow(data['type']);
                    setIntentTicket(data['intent_ticket']);
                    return [];
                } else if (statusButtons.includes(currentFlow) || HOME_BUTTONS.includes(currentButtonValue) || MIS_DAM_PRODUCT === currentButtonValue) {
                    return await fetchIntentsFromStorage(shippingId);
                }
                return [];
            }
            return [];
        } else {
            // console.log('intents data received', currentButtonValue);
            return await fetchIntentsFromStorage(shippingId);
        }
    } catch (error) {
        console.error('Error sending fetchIntentOfInput:', error);
        return [];
    }
}

export async function getWhereIsMyShipmentMessage(pddBreach, pdd) {
    const shipmentId = getAWBValue() || getNumber();
    const pddDisplay = (pdd || getEDD() || '').toString().split(/\s+/)[0];
    const pddCrossed = String(pddBreach ?? getPddBreach()).toLowerCase() === 'true';

    if (pddCrossed) {
        // Forward Flow row 5 — PDD crossed delay complaint (subReasonId 14)
        try {
            setIntentValue('14');
            setIntentName('complaint-raise-not-received');
            setIntentTicket('complaint-raise-not-received-ticket');
            const ticketData = await createComplintTicket(shipmentId, 'complaint-raise-not-received-yes');
            if (ticketData && typeof ticketData === 'string' && !/sorry|error|unable/i.test(ticketData)) {
                return ticketData;
            }
            const ticketRef = extractTicketRef(String(ticketData || ''));
            return formatWhereIsMyShipmentPddCrossedMessage(ticketRef);
        } catch (e) {
            console.error('[getWhereIsMyShipmentMessage] complaint ticket error:', e);
            return formatWhereIsMyShipmentPddCrossedMessage('');
        }
    }
    // Within PDD → enquiry (Forward Flow row 4 — subReasonId 1 Within PDD)
    try {
        setIntentValue('1');
        setIntentName('order-status');
        setIntentTicket('order-status-ticket');
        await createStatusTicket(shipmentId, 'order-status-ticket');
    } catch (e) {
        console.error('[getWhereIsMyShipmentMessage] enquiry ticket error:', e);
    }
    return `${constants.ORDER_STATUS_DATE} ${pddDisplay}.`;
}

export const FUTURE_DELIVERY_DATE_OPTION_COUNT = 3;

export async function getFutureDeliveryDates(response) {
    try {
        const today = new Date();
        // Offer the next three calendar days (+1, +2, +3).
        for (let i = 1; i <= FUTURE_DELIVERY_DATE_OPTION_COUNT; i += 1) {
            const date = new Date(today);
            date.setDate(today.getDate() + i);
            const formattedDate = `${date.getDate()}-${date.getMonth() + 1}-${date.getFullYear()}`;
            response.push({ type: 'date', content: formattedDate });
        }
        return response;
    } catch (error) {
        console.log('error in getFutureDeliveryDates');
        return [];  
    }
}

export const createUpdateTicket = async (updatedValue, ticket) => {
    try {
        
        // #enhancements_pxb5559 changes done according workflow enhancements
        let ticketDetails = await getTicketDetails();
        // Use AWB if available, fall back to registered mobile number (mobile-entry flow)
        const shipmentIdentifier = getAWBValue() || getNumber();
        // Derive name_extra from ticket name so the backend can read the date correctly
        const isDeliveryDate = ticket === 'update-delivery-date-yes' || getIntentName() === 'update-delivery-date';
        const isSelfCollect = ticket === 'update-selfCollect-date-yes' || getIntentName() === 'update-selfCollect-date';
        const isPickupDate = ticket === 'update-pickup-date-yes' || getIntentName() === 'update-pickup-date';
        const isContactNumber = ticket === 'update-contact-number-yes' || getIntentName() === 'update-contact-number';

        // Contact-number update must never take the Closed → createStatusTicket path.
        // That path is hijacked by pddBreach into complaint-raise (PDD Crossed) and
        // skips update-contact-number-yes entirely.
        if (
            ticketDetails
            && ticketDetails.length > 0
            && ticketDetails[0] === "Closed"
            && !isContactNumber
        ) {        
            await createStatusTicket(shipmentIdentifier, "closed-ticket");
            let msgResponse = ticketDetails[1];
            console.log('[createUpdateTicket] early-return (Closed), msgResponse:', msgResponse);
            if (msgResponse && msgResponse !== '') {
                return msgResponse;
            }
            return [];
        }
        let nameExtra;
        if (isDeliveryDate) {
            nameExtra = 'update-delivery-date';
        } else if (isSelfCollect) {
            nameExtra = 'update-selfCollect-date';
        } else if (isPickupDate) {
            nameExtra = 'update-pickup-date';
        } else if (isContactNumber) {
            nameExtra = 'update-contact-number';
        } else {
            nameExtra = getIntentName();
        }
        
        console.log('[createUpdateTicket] nameExtra:', nameExtra, '| updatedValue:', updatedValue);
        let ticketPayload = await createTicketPayload(shipmentIdentifier, ticket, nameExtra, updatedValue);
        if (isContactNumber) {
            console.log('[update-contact-number] request payload:', JSON.stringify(ticketPayload, null, 2));
        }
        const response = await fetch(config.chatbotbackendapi, await fetchHeaders(ticketPayload));
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        let result = await response.json();
        console.log('[createUpdateTicket] ticket API result:', result);
        if (isContactNumber) {
            console.log('[update-contact-number] full backend response:', JSON.stringify(result, null, 2));
            console.log('[update-contact-number] CRM ticket message:', result?.user?.crmTicketMessage || '(not returned)');
            const responseText = Array.isArray(result?.response)
                ? result.response.map((item) => item?.text || item?.content || JSON.stringify(item)).join(' | ')
                : '';
            console.log('[update-contact-number] UI message:', responseText);
        }
        if (getIntentName() == "update-delivery-date" || getIntentName() == "update-selfCollect-date" || getIntentName() == "update-pickup-date") {
            requestInsertionToDB('write', 'update', '', updatedValue)
        } else { 
            requestInsertionToDB('write', 'update', updatedValue, '');
        }
        let ticketData = await dataReceived(result);
        console.log('[createUpdateTicket] ticketData:', ticketData);
        // #enhancements_pxb5559 changes done according workflow enhancements
        if ((getCurrentFlow() === FUTURE_DATE_DELIVERY || getCurrentFlow() === RESCHEDULE_SHIPMENT || getCurrentFlow() === SELF_COLLECT || getCurrentFlow() === SELF_COLLECT_SHIPMENT) && ticketData && ticketData.includes("previous status is reattempt")) {
            setIntentValue("24");

            createStatusTicket(shipmentIdentifier, "closed-ticket");
            let msgResponse = ticketDetails[1];
            if (msgResponse && msgResponse !== '') {
                return msgResponse; 
            }
        }
        // Show delivery date confirmation for update-delivery-date intent or reschedule shipment flow or self-collect
        // Backend handles both success and error messages — always use ticketData
        if (getIntentName() === "update-delivery-date" || getIntentName() === "update-selfCollect-date" || getCurrentFlow() === RESCHEDULE_SHIPMENT || getCurrentFlow() === SELF_COLLECT || getCurrentFlow() === SELF_COLLECT_SHIPMENT || getCurrentFlow() === NDR_PNC_DATE_SELECTION) {
            if (ticketData && typeof ticketData === 'string' && ticketData.trim() !== '') {
                return ticketData;
            }
            return [];
        }
        return ticketData;
    } catch (error) {
        console.log('[createUpdateTicket] error:', error);
        return [];
    }
}

export const createStatusTicket = async (shipmentId, ticket) => {
    try {
        // #enhancements_pxb5559 changes done according workflow enhancements
        let isPddBreach = getPddBreach();
        if (isPddBreach === 'true') {
            setIntentValue('14');
            setIntentName('complaint-raise-not-received');
            setIntentTicket('complaint-raise-not-received-ticket');
            return createComplintTicket(getAWBValue(), 'complaint-raise-not-received-yes');
        }
        let ticketPayload = await createTicketPayload(shipmentId, ticket, "ticket_data", getIntentValue());
        const response = await fetch(config.chatbotbackendapi, await fetchHeaders(ticketPayload));
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        let result = await response.json();
        requestInsertionToDB('read', 'status', '', '');
        return [];
    } catch (error) {
        console.log('error in createStatusTicket', error);
        return [];
    }
}

const maybeCreateCwfpReattemptTicket = async (shippingId) => {
    if (getCurrentFlow() !== NPR_CWFP_REATTEMPT || getIntentValue() !== '59') {
        return;
    }
    if (sessionStorage.getItem(CWFP_REATTEMPT_TICKET_CREATED_KEY) === 'true') {
        return;
    }
    const awb = shippingId || getAWBValue();
    if (!awb) {
        return;
    }
    await createStatusTicket(awb, getIntentTicket() || 'order-status-ticket');
    sessionStorage.setItem(CWFP_REATTEMPT_TICKET_CREATED_KEY, 'true');
};

export const validateAddressPincode = async (pincode) => {
    try {
        const awb = getAWBValue();
        if (!awb) {
            return "Sorry! I couldn't find any shipments with the mentioned ID. \n Please enter a valid Shipment ID or your registered Mobile number.";
        }
        const ticketPayload = await createTicketPayload(awb, 'validate-pincode', 'pincode', pincode);
        const response = await fetch(config.chatbotbackendapi, await fetchHeaders(ticketPayload));
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const result = await response.json();
        if (result?.response?.length > 0 && result.response[0].type === 'text') {
            return result.response[0].text;
        }
        return await dataReceived(result);
    } catch (error) {
        console.log('error in validateAddressPincode', error);
        return [];
    }
}

const formatAddressUpdateSuccessMessage = (ticketRef) => {
    if (ticketRef) {
        return `We've created a ticket ${ticketRef} and your address has been updated successfully. Kindly note that if it's a pincode change, your delivery timeline might get extended and the shipment may arrive later than originally expected. We appreciate your patience and understanding.`;
    }
    return `We've created a ticket and your address has been updated successfully. Kindly note that if it's a pincode change, your delivery timeline might get extended and the shipment may arrive later than originally expected. We appreciate your patience and understanding.`;
};

const formatWhereIsMyShipmentPddCrossedMessage = (ticketRef) => {
    const base = constants.DELAY_APOLOGY_MESSAGE;
    if (ticketRef) {
        return `${base} We have created the ticket ${ticketRef}.`;
    }
    return base;
};

const extractWebhookText = (result) => {
    if (!result?.response?.length) {
        return '';
    }
    return result.response
        .filter((item) => item?.type === 'text' && item?.text)
        .map((item) => item.text)
        .join(' ')
        .trim();
};

export async function fetchRecordsResponse(input) {
    try {
        const payload = await createPayload(input, fetchRecordsPrompt);
        const response = await fetch(config.chatbotbackendapi, await fetchHeaders(payload));
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const result = await response.json();
        if (result && Array.isArray(result.response)) {
            return result.response;
        }
        return [];
    } catch (error) {
        console.error('Error fetching records response:', error);
        return [];
    }
}

// Disagree flows that route through the IVR call-attempt picker. If the fetch
// fails inside one of these, we must NOT leave the user stranded in the
// *_CALL_LOG flow — the call-log/disagree ticket handler keys off currentFlow,
// so a later menu re-selection would be treated as a call-log pick and raise a
// ticket. We undo just the disagree navigation and offer the standard
// "anything else?" options; the shipment session (AWB / OTP / snapshot) stays.
const IVR_CALL_LOG_DISAGREE_FLOWS = [
    NDR_CWFD_CALL_LOG,
    NDR_CRA_CALL_LOG,
    NDR_ADI_CALL_LOG,
    NPR_HANDED_CALL_LOG,
    NPR_ADI_CALL_LOG,
    NPR_CWFP_CALL_LOG,
    RPCANCEL_PICKUP_CALL_LOG,
];

export { IVR_CALL_LOG_DISAGREE_FLOWS };

const CALL_LOG_FETCH_ERROR_MSG = 'An error occurred while fetching call attempts. Please try again.';
const CALL_LOG_DISAGREE_PROMPT = (
  'Could you please help us understand which particular attempt you disagree with?'
);

export const IVR_CALL_LOG_CALENDAR_PROMPT = (
  'Please select the date from the calendar below'
);
export const IVR_CALL_LOG_CALENDAR_OPEN_BUTTON = 'Select date from calendar';
const IVR_CALENDAR_DATE_SELECTED_KEY = 'ivr_calendar_date_selected';
const IVR_CALL_LOG_BUTTON_RE = /^\d{2}-\d{2}-\d{4}\s*\|\s*\d{2}:\d{2}(?::\d{2})?$/;
const IVR_NO_CALL_ATTEMPTS_RE = /no call attempts were found/i;

export const isIvrCallLogButtonLabel = (label) => {
  const normalized = String(label || '').trim();
  if (!normalized) {
    return false;
  }
  if (normalized.startsWith('Call log')) {
    return true;
  }
  return IVR_CALL_LOG_BUTTON_RE.test(normalized);
};

const resetIvrCalendarSelectionState = () => {
  if (typeof sessionStorage !== 'undefined') {
    sessionStorage.removeItem(IVR_CALENDAR_DATE_SELECTED_KEY);
  }
};

/**
 * When IVR returns no call-log date buttons, show the disagree prompt and an
 * inline calendar so the customer can still pick an attempt date.
 */
export function buildIvrCallLogCalendarFallback(priorMessages = []) {
  resetIvrCalendarSelectionState();
  const texts = (Array.isArray(priorMessages) ? priorMessages : [])
    .filter((option) => (
      option?.type === 'text'
      && option.content
      && !IVR_NO_CALL_ATTEMPTS_RE.test(option.content)
    ));
  const disagreePrompt = texts.find((option) => /disagree with/i.test(option.content))?.content
    || CALL_LOG_DISAGREE_PROMPT;
  return [
    { type: 'text', content: disagreePrompt },
    { type: 'text', content: IVR_CALL_LOG_CALENDAR_PROMPT },
    { type: 'calendar', calendarActive: true, calendarLocked: false },
  ];
}

/** Opens calendar via button click (fetch-records / backend disagree path). */
export function buildIvrCallLogCalendarOptions() {
  resetIvrCalendarSelectionState();
  return [
    { type: 'text', content: IVR_CALL_LOG_CALENDAR_PROMPT },
    { type: 'button', content: IVR_CALL_LOG_CALENDAR_OPEN_BUTTON },
  ];
}

const flattenIvrCallLogResponse = (items) => {
  const flattened = [];
  items.forEach((item) => {
    if (item?.type === 'text' && item.text) {
      flattened.push({ type: 'text', content: item.text });
    } else if (item?.type === 'buttons' && Array.isArray(item.buttons)) {
      item.buttons.forEach((btn) => {
        if (btn?.content) {
          flattened.push({
            type: btn.type || 'button',
            content: btn.content,
          });
        }
      });
    } else if (item?.content) {
      flattened.push({
        type: item.type || 'text',
        content: item.content,
      });
    }
  });
  return flattened;
};

const hasIvrCallLogDateButtons = (options) => (
  Array.isArray(options)
  && options.some((option) => (
    option?.type === 'button' && isIvrCallLogButtonLabel(option.content)
  ))
);

/**
 * Failure handler for fetchIvrCallLogOptions. In a disagree (*_CALL_LOG) flow it
 * undoes the disagree navigation (so a later click isn't taken as a call-log
 * pick that raises a ticket) and returns the error message plus the standard
 * "Additional options" prompt. The shipment session is left untouched. In any
 * other context (e.g. the rider-concern date picker) it just returns the error
 * string so the caller's own fallback runs.
 */
async function handleIvrCallLogFailure() {
    if (!IVR_CALL_LOG_DISAGREE_FLOWS.includes(getCurrentFlow())) {
        return CALL_LOG_FETCH_ERROR_MSG;
    }
    // Reset only the flow/ticket navigation — NOT the shipment session.
    setCurrentFlow('');
    setButtonName('');
    setIntentName('');
    setIntentTicket('');
    setIntentValue('');
    const options = await fetchOptionsOfInput(constants.prompt_of_additional_options, false);
    const messages = [{ type: 'text', content: CALL_LOG_FETCH_ERROR_MSG }];
    if (Array.isArray(options) && options.length > 0) {
        messages.push(...options);
    }
    return messages;
}

/**
 * Fetch IVR call-attempt buttons for disagree / incident-date flows.
 * Returns call-log date buttons when IVR has rows; otherwise inline calendar.
 */
export async function fetchIvrCallLogOptions(shippingId) {
    try {
        const awb = shippingId || getAWBValue();
        if (!awb) {
            return 'Unable to fetch call attempts — shipment reference missing. Please try again.';
        }
        const payload = await createPayload(awb, 'fetch-ivr-call-logs');
        if (payload?.intent?.entities?.[0]) {
            payload.intent.entities[0].name = 'shipment_id';
            payload.intent.entities[0].value = awb;
        }
        payload.user = {
            ...(payload.user || {}),
            authKey: '111111',
            shipment_id: awb,
        };
        const response = await fetch(config.chatbotbackendapi, await fetchHeaders(payload));
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const result = await response.json();
        const items = Array.isArray(result?.response) ? result.response : [];
        if (items.length === 0) {
            return buildIvrCallLogCalendarFallback();
        }
        const flattened = flattenIvrCallLogResponse(items);
        if (flattened.length === 0) {
            return buildIvrCallLogCalendarFallback();
        }
        if (hasIvrCallLogDateButtons(flattened)) {
            return flattened;
        }
        return buildIvrCallLogCalendarFallback(flattened);
    } catch (error) {
        console.error('Error fetching IVR call log options:', error);
        return handleIvrCallLogFailure();
    }
}

export const createRiderConcernTicket = async (concernType, description, incidentDate) => {
    try {
        const awb = getAWBValue();
        if (!awb) {
            return "Sorry! I couldn't find any shipments with the mentioned ID. \n Please enter a valid Shipment ID or your registered Mobile number.";
        }
        const payload = await createRiderConcernPayload(awb, concernType, description, incidentDate);
        const response = await fetch(config.chatbotbackendapi, await fetchHeaders(payload));
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const result = await response.json();
        if (result?.response?.length > 0 && result.response[0].text) {
            return result.response[0].text;
        }
        return await dataReceived(result);
    } catch (error) {
        console.log('error in createRiderConcernTicket', error);
        return 'Sorry, we could not register your concern right now. Please contact our Customer Care on 020-49116100.';
    }
};

export const parseUserDateToIso = (input) => {
    const trimmed = String(input || '').trim();
    if (!trimmed) {
        return null;
    }
    if (/^\d{4}-\d{2}-\d{2}$/.test(trimmed)) {
        return trimmed;
    }
    const parts = trimmed.split('-');
    if (parts.length !== 3) {
        return null;
    }
    const [day, month, year] = parts;
    if (year.length !== 4 || Number.isNaN(Number(day)) || Number.isNaN(Number(month))) {
        return null;
    }
    return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
};

const isPlausibleTicketRef = (value) => {
    const id = String(value || '').trim();
    // Reject CSS leftovers like "-number" from class="ticket-number".
    if (!id || id === '-' || /^number$/i.test(id) || /^-/i.test(id)) {
        return false;
    }
    return /^[A-Za-z0-9]+(?:-[A-Za-z0-9]+)*$/.test(id);
};

const extractTicketRef = (text) => {
    const value = String(text || '');
    // Backend often wraps ids as <strong class="ticket-number">12345</strong>.
    const markupMatch = value.match(
        /class=["'][^"']*ticket-number[^"']*["'][^>]*>\s*([^<]+?)\s*</i
    );
    if (markupMatch?.[1] && isPlausibleTicketRef(markupMatch[1])) {
        return markupMatch[1].trim();
    }
    const stripped = value.replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim();
    const patterns = [
        /created (?:the |a )?ticket\s+([A-Za-z0-9]+)/i,
        /ticket\s*(?:no\.?|#)\s*:?\s*([A-Za-z0-9-]+)/i,
        /Ticket\s*#\s*([A-Za-z0-9-]+)/i,
        /"(\d+)"/,
    ];
    for (const pattern of patterns) {
        const match = stripped.match(pattern);
        if (match?.[1] && isPlausibleTicketRef(match[1])) {
            return match[1].trim();
        }
    }
    return '';
};

const isNdrCallLogDisagreeSuccessMessage = (text) => (
    /we have taken a note of it/i.test(text)
    && /working on it/i.test(text)
);

const formatCwfdDisagreeTicketMessage = (ticketData, buttonName) => {
    let raw = '';
    if (Array.isArray(ticketData)) {
        raw = ticketData.map((item) => item?.content || item?.text || '').join(' ').trim();
    } else {
        raw = String(ticketData || '');
    }
    if (isNdrCallLogDisagreeSuccessMessage(raw)) {
        return raw;
    }
    if (!raw || raw.includes('Sorry') || raw.includes('Open ticket') || raw.includes('already exists') || raw.includes('Can I assist you with something else')) {
        return raw.includes('Can I assist you with something else')
            ? "Sorry, we could not register your complaint right now. Please try again."
            : (raw || "Sorry, we could not register your complaint right now. Please try again.");
    }
    const ticketRef = extractTicketRef(raw);
    const isOtpAttempt = String(buttonName || '').trim().toUpperCase().startsWith('OTP');
    if (ticketRef) {
        return isOtpAttempt
            ? `We have taken a note of it! We've created a ticket ${ticketRef} and your shipment will be attempted. Thankyou.`
            : `We have taken a note of it! We've created a ticket ${ticketRef} and we are working on it. Thankyou.`;
    }
    return isOtpAttempt
        ? "We have taken a note of it! We've created a ticket and your shipment will be attempted. Thankyou."
        : "We have taken a note of it! We've created a ticket and we are working on it. Thankyou.";
};

export const submitAddressUpdate = async (address) => {
    try {
        const awb = getAWBValue();
        const pincode = getAddressPincode()
            || sessionStorage.getItem('update_address_pincode')
            || '';
        if (!awb) {
            return 'Sorry, we could not update your address because the shipment ID is missing. Please start again with your AWB.';
        }
        if (!pincode) {
            return 'Sorry, we could not update your address because the pincode is missing. Please enter your pincode again.';
        }
        const ticketPayload = await createAddressUpdatePayload(awb, pincode, address);
        const response = await fetch(config.chatbotbackendapi, await fetchHeaders(ticketPayload));
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const result = await response.json();
        const backendText = extractWebhookText(result);
        if (!backendText) {
            console.log('submitAddressUpdate: empty backend text', result);
            return 'Sorry, we could not update your address right now. Please try again.';
        }
        if (/created a ticket|address has (?:already )?been updated/i.test(backendText)) {
            requestInsertionToDB('write', 'update', address, pincode);
            const ticketRef = extractTicketRef(backendText);
            // Prefer a clean success line with the real CRM id (never CSS leftovers like "-number").
            return formatAddressUpdateSuccessMessage(ticketRef);
        }
        const ticketRef = extractTicketRef(backendText);
        if (ticketRef && !/error|sorry|unable|already exists/i.test(backendText)) {
            requestInsertionToDB('write', 'update', address, pincode);
            return formatAddressUpdateSuccessMessage(ticketRef);
        }
        // Surface the real backend message instead of a generic fallback.
        return backendText;
    } catch (error) {
        console.log('error in submitAddressUpdate', error);
        return 'Sorry, we could not update your address right now. Please try again.';
    }
}

async function updateIntentValues() {
    try {
        let currentFlow = getCurrentFlow();
        let flag = false;
        // #enhancements_pxb5559 changes done according workflow enhancements
        if (currentFlow === WRONG_PRODUCT_PICKED) {
            setIntentValue("56");
            flag = true;
        } else if ( currentFlow === PRODUCT_NOT_PICKED && getButtonName() !== "No, the shipment is not yet picked." && getButtonName() !== "Ok, Kindly pick the shipment quickly." && getButtonName() !== "I do not agree with the reason for non-pickup provided.") {
            setIntentValue("90");
            flag = true;
        } else if ( currentFlow === MISBEHAVIOR_BY_SR) {
            flag = false;
            setIntentValue("21");
        } else if ( currentFlow === CHARGED_EXTRA_AMOUNT) {
            flag = false;
            setIntentValue("19");
        } else {
            flag = false;
        }
        return flag ? "ticket_data" : "complaint-raise";
    } catch (error) {
        console.log('error in updateIntentValues', error);
    }
}

export const createComplintTicket = async (shipmentId, ticket) => {
    try {
        if (!shipmentId) {
            shipmentId = getAWBValue();
        }
        if (!ticket) {
            ticket = getIntentTicket();
        }
        const name_extra = await updateIntentValues();
        console.log("name extra>>>>>>>>>>>>>>>>>>>>>>>",name_extra);
        
        // #enhancements_pxb5559 changes done according workflow enhancements
        let ticketDetails = await getTicketDetails();
        let buttonName = getButtonName();
        let currentFlow = getCurrentFlow();
        let delayFlag = false;
        const isDeliveredIncorrectShipment = (
            getIntentValue() === '135'
            || currentFlow === DELIVERED_INCORRECT_SHIPMENT_FLOW
            || (buttonName && String(buttonName).toLowerCase().includes('incorrect shipment'))
        );
        console.log(`ticketDetails.length ${ticketDetails.length} >>>>>>>>> buttonName ${ticketDetails[0]} currentFlow `);
        
        if (
            ticketDetails
            && ticketDetails.length > 0
            && ticketDetails[0] === "Closed"
            && ticket !== 'complaint-raise-not-received-yes'
            && !isDeliveredIncorrectShipment
        ) {
            console.log("inside ticket close");            
            ticket = "closed-ticket";
        } else if
         (getIntentValue() === "139" || getIntentValue() === "131") {
            delayFlag = true;
        }
        let ticketPayload = await createTicketPayload(shipmentId, ticket, name_extra, getIntentValue());
        if (delayFlag) {
            ticketPayload = await createDelayPayload(shipmentId, "update-delay-date-yes", "update-delay-date");
        }
        const response = await fetch(config.chatbotbackendapi, await fetchHeaders(ticketPayload));
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        let result = await response.json();
        requestInsertionToDB('write', 'complaint', '', '');
        const isCwfdCallLog = currentFlow === NDR_CWFD_CALL_LOG;
        const isCraCallLog = currentFlow === NDR_CRA_CALL_LOG;
        const isHandedCallLog = currentFlow === NPR_HANDED_CALL_LOG;
        const isNprAdiCallLog = currentFlow === NPR_ADI_CALL_LOG;
        const isNprCwfpCallLog = currentFlow === NPR_CWFP_CALL_LOG;
        const isRpcancelPickupCallLog = currentFlow === RPCANCEL_PICKUP_CALL_LOG;
        const isCallLogDisagreeFlow = (
            isCwfdCallLog
            || isCraCallLog
            || isHandedCallLog
            || isNprAdiCallLog
            || isNprCwfpCallLog
            || isRpcancelPickupCallLog
            || currentFlow === NDR_ADI_CALL_LOG
        );
        let ticketData = isCallLogDisagreeFlow ? extractWebhookText(result) : await dataReceived(result);
        if (isCallLogDisagreeFlow) {
            return formatCwfdDisagreeTicketMessage(ticketData, buttonName);
        }
        // #enhancements_pxb5559 changes done according workflow enhancements
        if (ticketDetails && ticketDetails.length > 0 && ticket === "closed-ticket") {
            let msgResponse = ticketDetails[1];
            if (msgResponse && msgResponse !== '') {
                return msgResponse;
            }
        } else if (ticketData && !(ticketData.includes('Sorry') || ticketData.includes('Open ticket'))) {
            if (buttonName === "I do not agree with the reason for non-pickup provided." || buttonName === "Ok, Kindly pick the shipment quickly.") {
                let ticketNum = ticketData.replace(/\D/g, '');
                let prompt = `Your complaint has been registered (Ticket #${ticketNum}), and our team will contact you with updates.`;
                return ticketNum !== '' ? prompt : ticketData;
            } else if (buttonName === "No, I have not received my shipment" || buttonName === "No, the shipment is not yet picked.") {
                let ticketNum = ticketData.replace(/\D/g, '');
                let prompt = `We apologize for the inconvenience! Let us look into this on priority. Your complaint has been registered (Ticket #${ticketNum}), and our team will contact you with updates.`;
                return ticketNum !== '' ? prompt : ticketData;
            } else if (currentFlow === SHIPMENT_NOT_RECEIVED) {
                let ticketNum = ticketData.replace(/\D/g, '');
                let prompt = `Your complaint has been registered (Ticket #${ticketNum}), and our team will contact you shortly with updates. Thank you for your patience and understanding!`;
                if (ticketDetails && ticketDetails.length > 0 && ticketDetails[1] !== '') {
                    let msgResponse = ticketDetails[1];
                    return ticketNum !== '' ? `${msgResponse}\n${prompt}` : msgResponse;
                }
                return ticketNum !== '' ? prompt : ticketData;
            } else if (currentFlow === MISBEHAVIOR_BY_SR) {
                let ticketNum = ticketData.replace(/\D/g, '');
                let prompt = `We're sorry to hear about your experience. Your complaint regarding misbehavior by the service representative has been registered successfully. Your ticket number is #${ticketNum}. Our team will investigate the matter and get in touch with you shortly with updates. Thank you for bringing this to our attention!`;
                return ticketNum !== '' ? prompt : ticketData;
            } else if (currentFlow === CHARGED_EXTRA_AMOUNT) {
                let ticketNum = ticketData.replace(/\D/g, '');
                let prompt = `We apologize for the inconvenience. Your complaint regarding the extra amount charged by the service representative has been successfully registered. Your ticket number is #${ticketNum}. Our team will investigate the matter and reach out to you shortly with updates. Thank you for bringing this to our attention!`;
                return ticketNum !== '' ? prompt : ticketData;
            } else if (currentFlow === WRONG_PRODUCT_PICKED) {
                let ticketNum = ticketData.replace(/\D/g, '');
                let prompt = `We apologize for the inconvenience. Your complaint regarding the wrong product being picked by the service representative has been successfully registered. Your ticket number is #${ticketNum}. Our team will investigate the matter and contact you with updates shortly.`;
                return ticketNum !== '' ? prompt : ticketData;
            } else if (currentFlow === PRODUCT_DAMAGED) {
                let ticketNum = ticketData.replace(/\D/g, '');
                let prompt = `We apologize for the inconvenience. Your complaint regarding the product being damaged has been successfully registered. Your ticket number is #${ticketNum}. Our team will investigate the matter and contact you with updates shortly. Thank you for bringing this to our attention!`;
                return ticketNum !== '' ? prompt : ticketData;
            } else if (currentFlow === PRODUCT_MISSING) {
                let ticketNum = ticketData.replace(/\D/g, '');
                let prompt = `We apologize for the inconvenience. Your complaint regarding the product being missing has been successfully registered. Your ticket number is #${ticketNum}. Our team will investigate the matter and contact you with updates shortly. Thank you for bringing this to our attention!`;
                return ticketNum !== '' ? prompt : ticketData;
            } else if (isDeliveredIncorrectShipment) {
                const ticketNum = String(ticketData).replace(/\D/g, '');
                const ticketRef = ticketNum || String(ticketData).trim();
                return (
                    `We have taken a note of it! We've created a ticket ${ticketRef} and we are working on it. Thank you. `
                    + `Meanwhile you can also reach out at our customer care at ${CUSTOMER_CARE_CLICKABLE}`
                );
            }
        }
        return ticketData;
    } catch (error) {
        console.log('error in createStatusTicket', error);
        return [];
    }
}

export const requestInsertionToDB = async (operation, type, updatedNo, updatedDate) => {
    try {
        const payload = await  createRequestPayload(getNumber(), operation, getIntentTicket(), getAWBValue(), getCurrentFlow(), updatedNo, updatedDate, type)
        const response = await fetch(config.chatbotbackendapi, await fetchHeaders(payload));
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        let result = await response.json();
        // console.log('result -------->>>', result)
    } catch (error) {
        console.log('error in requestInsertionToDB', error);
        return;
    }
}

// #features_pxb5559 — AWB fetch-mobile-no returns plain 10-digit OR enc_v1:...
// Stage stores OTP under that same value and SMS accepts enc_v1; UI must accept both.
const isPresentRegisteredMobileValue = (value) => {
    const raw = String(value || '').trim();
    if (!raw || raw === 'None' || raw === 'null') {
        return false;
    }
    if (raw.startsWith('enc_v1:') && raw.length > 'enc_v1:'.length) {
        return true;
    }
    // Plain registered mobile (optional 91 prefix stripped by normalizeMobileInput).
    const digits = raw.replace(/\D/g, '');
    if (digits.length === 12 && digits.startsWith('91')) {
        return true;
    }
    return digits.length === 10;
};

const extractRegisteredMobileFromWebhook = (result) => {
    const items = result?.response;
    if (!Array.isArray(items)) {
        return null;
    }
    for (const item of items) {
        if (!item || item.text == null) {
            continue;
        }
        const rawText = String(item.text).trim();
        if (!rawText) {
            continue;
        }
        // Prefer encrypted or digit tokens over error sentences.
        if (isPresentRegisteredMobileValue(rawText)) {
            return rawText;
        }
    }
    // First non-empty text that is not a mobile (error copy) — for UI message.
    for (const item of items) {
        if (!item || item.text == null) {
            continue;
        }
        const rawText = String(item.text).trim();
        if (rawText && rawText !== 'None' && rawText !== 'null') {
            return { errorText: rawText };
        }
    }
    return null;
};

export const validateShippingID = async (shippingId) => {
    try {
        const { normalizeMobileInput } = require('../js/payloads');
        let shippingID = shippingId ? shippingId : getAWBValue();
        const payload = await createAwbDetailsPayload(shippingID );
        const response = await fetch(config.chatbotbackendapi, await fetchHeaders(payload));
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        let result = await response.json();
        const extracted = extractRegisteredMobileFromWebhook(result);
        if (typeof extracted === 'string') {
            // Keep enc_v1 as-is (normalize only strips 91 prefix from plain digit mobiles).
            const data = normalizeMobileInput(extracted);
            setRegisteredNo(data);
            setNumber(data);
            return data;
        }
        if (extracted?.errorText) {
            return { error: 'lookup', message: extracted.errorText };
        }
        return false;
    } catch (error) {
        console.error('Error sending webhook data:', error);
        const message = String(error?.message || '');
        if (
            message.includes('access token')
            || message.includes('Authentication failed')
            || message.includes('Valid access token')
        ) {
            return { error: 'auth' };
        }
        // Network/CORS/parse failures must not look like an invalid AWB.
        return {
            error: 'lookup',
            message: 'Unable to fetch your registered mobile number right now. Please try again in a moment.',
        };
    }
}

// #enhancements_pxb5559 changes done according workflow enhancements
export const getShipmentTypeFromInput = async (shippingId) => {
    try {
        let shippingID = shippingId ? shippingId : getAWBValue();
        let currentFlow = getCurrentFlow();
        if (currentFlow === '') {
            currentFlow = getButtonName();
        }
        let isAWBChar = shippingID[0];
        const isFWD = isAWBChar === '1' && fwdButtons.includes(currentFlow);
        const isRVP = isAWBChar === '2' && rvpButtons.includes(currentFlow);
        if (isFWD || isRVP) {
            return 'true';
        } else if (!(fwdButtons.includes(currentFlow) || rvpButtons.includes(currentFlow))) {
            return 'true';
        }
        return isAWBChar === '1' ?  "Kindly provide a valid shipment ID" : (currentFlow === PRODUCT_DAMAGED || currentFlow === PRODUCT_MISSING) 
                                 ? "Kindly provide a valid delivery shipment ID": "Kindly provide a valid shipment ID for which you are expecting delivery";
    } catch (error) {
        console.error('Error sending webhook data:', error);
        return 'false';
    }
}

export const getTicketDetails= async () => {
    try {
        let shippingID = getAWBValue();
        let currentFlow = getCurrentFlow();
        let currentButton = getButtonName();
        let shipmentStatus = getShipmentStatus();
        let attempts = getAttemptCount();
        let ticketType = "Closed";
        let isPddBreach = getPddBreach();
        let eddDate = getEDD();
        let prompt = '';
        let delivertDate = getDDT();
        // #enhancements_pxb5559 changes done according workflow enhancements
        if (delivertDate && delivertDate != '') {
            delivertDate = delivertDate.split(" ")[0];
        }
        let clientName = getClientName();
        let shipmentType = getShipmentType();
        let reattemptDate = getReattemptDate();
        let ndrReason = getNDR();
        let ndrDate = getNDRDate();
        
        // Fallback: if currentFlow is empty, check currentButton for flow identification
        if (!currentFlow && currentButton) {
            if (currentButton.includes(RESCHEDULE_SHIPMENT) || currentButton.includes(FUTURE_DATE_DELIVERY)) {
                currentFlow = RESCHEDULE_SHIPMENT;
            } else if (currentButton.includes(SELF_COLLECT) || currentButton.includes(SELF_COLLECT_SHIPMENT) || currentButton.toLowerCase().includes('self collect')) {
                currentFlow = SELF_COLLECT;
            } else if (currentButton.includes(FUTURE_PICKUP_DATE)) {
                currentFlow = FUTURE_PICKUP_DATE;
            } else if (
                currentButton.includes(UPDATE_ALTERNATE_CONTACT)
                || currentButton.toLowerCase().includes('alternate contact')
                || currentButton.toLowerCase().includes('alternate mobile')
            ) {
                currentFlow = UPDATE_ALTERNATE_CONTACT;
            } else if (currentButton.toLowerCase().includes(WHERE_IS_MY_SHIPMENT.toLowerCase())) {
                // Forward Flow row 5 — PDD crossed delay complaint
                if (isPddBreach === 'true') {
                    setIntentValue('14');
                    ticketType = "Open";
                    return [ticketType, prompt];
                }
            }
        }
        
        if (currentFlow === DELIVERY_DATE_ENQUIRY) {
            if (isPddBreach === 'true' && shipmentStatus === 'OFD') {
                setIntentValue("139")
            } else if (isPddBreach === 'true' && attempts === 0 && shipmentStatus === 'Inscan') {
                ticketType = "Open";
                setIntentValue("139");
            }
        } else if (currentFlow === FUTURE_DATE_DELIVERY || currentFlow === RESCHEDULE_SHIPMENT) {
            if (shipmentStatus === "Inscan" && attempts >= 1) {
                ticketType = "Open";
                prompt = "Shipment already in reattempt. It is not eligible for future delivery date change.";
            } else if (shipmentStatus === "Manifestation" || shipmentStatus === "OFD") {
                setIntentValue("24");
                prompt = "The shipment has not yet been attempted for delivery, and as such, I won't be able to update the delivery date at this time. Thank you for your understanding!";
            } else if (shipmentStatus === "Inscan") {
                // Allow ticket creation for Inscan shipments (including 0 attempts)
                ticketType = "Open";
            } else if (shipmentStatus === "Delivered") {
                setIntentValue("24");
                prompt = `The shipment was successfully delivered on ${delivertDate}. It is not eligible for a future delivery date change.`;
            } else if (shipmentStatus === "RTO") {
                setIntentValue("24");
                prompt = `The shipment with ID ${shippingID} is a prepaid order placed through ${clientName}. As per the instructions from the client, the shipment will be returned to its origin. For any queries or further details, please contact the client directly`;
            } else {
                // All other statuses (NDR, Reattempt, etc.) are eligible for delivery date update
                ticketType = "Open";
            }
        } else if (
            currentFlow === UPDATE_ALTERNATE_CONTACT
            || String(currentFlow || '').toLowerCase().includes('alternate contact')
            || String(currentFlow || '').toLowerCase().includes('alternate mobile')
            || getIntentName() === 'update-contact-number'
        ) {
            setIntentValue("98");
            if ((shipmentStatus === "Delivered") && getBusinessType() === "forward") {
                prompt = "Your shipment has already been delivered, so the mobile number cannot be updated at this stage. Thank you for your understanding!";
            } else if ((shipmentStatus === "Inscan" || shipmentStatus === "PickedUp") && getBusinessType() === "reverse") {
                prompt = "Your shipment has already been picked, so the mobile number cannot be updated at this stage. Thank you for your understanding!";
            } else {
                ticketType = "Open";
            }
        } else if (currentFlow === RESCHEDULE_PICKUP || currentButton === RESCHEDULE_PICKUP) {
            // Pending-for-Pickup reschedule — the shipment is in
            // Pending+Reverse state, which is always eligible for a
            // future pickup-date change per the flowchart (calendar lock
            // for next 3 days). Skip the shipment-status gating that the
            // forward FUTURE_PICKUP_DATE branch uses and just return
            // Open so createUpdateTicket doesn't early-return with a
            // closed-ticket. Downstream fires update-pickup-date-yes,
            // which builds the payload via update_pickup_date_ticket_
            // payload (ticketTypeId=3, reasonId=14, subReasonId=59,
            // action=11, status=Open — spec-correct per the CRM XLSX).
            ticketType = "Open";
        } else if (currentFlow === FUTURE_PICKUP_DATE) {
            if (shipmentStatus === "Manifestation" && attempts >= 1) {
                ticketType = "Open";
                prompt = "Shipment already in reattempt. It is not eligible for pickup date change.";
            } else if (shipmentStatus === "Manifestation" || shipmentStatus === "Inscan" || shipmentStatus === "OFP") {
                setIntentValue("59");
                prompt = "The shipment has not yet been attempted for pickup, and as such, I won't be able to update the pickup date at this time. Thank you for your understanding!";
            } else if (shipmentStatus === "PickedUp") {
                setIntentValue("59");
                prompt = `The shipment has been already picked up on ${delivertDate}. It is not eligible for a future pickup date change.`;
            } else if (shipmentStatus === "DTO" && getWHHandOver() === 'true') {
                setIntentValue("59");
                prompt = `The pickup request for Shipment ID ${shippingID} was initiated by ${clientName}. We have successfully picked up the product on ${delivertDate}, and it is delivered to its origin. For any queries, please feel free to contact ${clientName} directly. Thank you for your understanding!`;
            } else if (shipmentStatus === "DTO") {
                setIntentValue("59");
                prompt = `The pickup request for Shipment ID ${shippingID} was initiated by ${clientName}. We have successfully picked up the product on ${delivertDate}, and it will be delivered to its origin very soon. For any queries, please feel free to contact ${clientName} directly. Thank you for your understanding!`;
            }
        } else if (currentFlow === SELF_COLLECT || currentFlow === SELF_COLLECT_SHIPMENT) {
            if (shipmentStatus === "Inscan" && attempts >= 1) {
                ticketType = "Open";
                prompt = "Shipment already in reattempt. It is not eligible for self collect date change.";
            } else if (shipmentStatus === "Manifestation" || shipmentStatus === "OFD") {
                setIntentValue("26");
                prompt = "The shipment has not yet been attempted for delivery, and as such, I won't be able to update the self collect date at this time. Thank you for your understanding!";
            } else if (shipmentStatus === "Inscan") {
                // Allow ticket creation for Inscan shipments (including 0 attempts)
                ticketType = "Open";
            } else if (shipmentStatus === "Delivered") {
                setIntentValue("26");
                prompt = `The shipment was successfully delivered on ${delivertDate}. It is not eligible for self collect.`;
            } else if (shipmentStatus === "RTO") {
                setIntentValue("26");
                prompt = `The shipment with ID ${shippingID} is a prepaid order placed through ${clientName}. As per the instructions from the client, the shipment will be returned to its origin. For any queries or further details, please contact the client directly`;
            } else {
                // All other statuses are eligible for self collect
                ticketType = "Open";
            }
        } else if (currentFlow === SHIPMENT_NOT_RECEIVED) {
            if (currentButton === "I do not agree with the reason of non delivery provided." || currentButton === "Ok, deliver the shipment quickly.") {
                return ["Open", ''];
            } else if (currentButton === "Yes, I have received my shipment") {
                return [ticketType, 'Great!'];
            } else if (currentButton === "No, I have not received my shipment") {
                ticketType = "Open";
                prompt = "We apologize for the inconvenience! Let us look into this on priority.";
            } else if ((shipmentStatus === "Manifestation" || shipmentStatus === "Inscan")) {
                setIntentValue("108");
                if (eddDate && eddDate !== '' && eddDate !== 'null' && eddDate !== 'None') {
                    setIntentValue("1");
                }
                if (shipmentStatus === "Manifestation") {
                    prompt = `We hear you and truly understand your concern. As your shipment is yet to be picked up from the vendor or warehouse, we are currently unable to register a complaint. Please rest assured that we're keeping track of it, and you can check back later for an updated status. Thank you for your patience and understanding!`;
                } else if (shipmentStatus === "Inscan" && eddDate && isPddBreach === 'false' && attempts === 0) {
                    setIntentValue("1");
                    prompt =  `We hear you! Your shipment is on track for delivery within the estimated timeframe. Since the expected delivery date hasn't passed yet, a complaint cannot be registered at this time. Rest assured, we're working to get your order to you as scheduled. Let us know if you need any further assistance!`;
                } else if (isPddBreach === 'true' && shipmentStatus === "Inscan" && attempts === 0) {
                    ticketType = "Open"
                    setIntentValue("139")
                } else if (shipmentStatus === "Inscan" && attempts >= 1) {
                    if (reattemptDate && reattemptDate != '' && reattemptDate != 'None') {
                        prompt = `The shipment with ID ${shippingID} is a ${shipmentType} order placed through ${clientName}. We were unable to deliver it due to ${ndrReason} on ${ndrDate}. We will reattempt delivery on ${reattemptDate}.`;
                    } else {
                        prompt = `The shipment with ID ${shippingID} is a ${shipmentType} order placed through ${clientName}. We were unable to deliver it due to ${ndrReason} on ${ndrDate}. We are currently awaiting further instructions from the client. Once we receive the updated delivery date, we will process the request and ensure the shipment is delivered as soon as possible.`;
                    }
                } 
            } else if (shipmentStatus === "OFD") {
                setIntentValue("1");
                if (isPddBreach === 'true') {
                    setIntentValue("139");
                    prompt = `The shipment is out for delivery today. Our service representative will contact you shortly to ensure smooth delivery. Thank you for your understanding and patience!`;
                } else {
                    prompt = `We hear you! Your shipment is on track for delivery within the estimated timeframe. Since the expected delivery date hasn't passed yet, a complaint cannot be registered at this time. Good news! It is out for delivery today. Our service representative will contact you shortly to ensure smooth delivery. Thank you for your understanding and patience!`;
                }
            } else if (shipmentStatus === "Delivered") {
                prompt = `The shipment with ID ${shippingID} is a ${shipmentType} order placed through ${clientName}. We are pleased to inform you that it has been successfully delivered on ${delivertDate}.`;
            } else if (shipmentStatus === "RTO" && getWHHandOver() === 'true') {
                setIntentValue("107");
                prompt = `We understand your concern and truly appreciate you reaching out. As per our records, this shipment was marked as RTO (Return to Origin) and has been returned to the vendor, so we're unable to register a complaint in this case. If you need any further assistance or have any questions, please don't hesitate to reach out. We're here to help!`;
            } else if (shipmentStatus === "RTO") {
                setIntentValue("2");
                prompt = `We understand your concern and truly appreciate you reaching out. As per our records, this shipment was marked as RTO (Return to Origin), so we're unable to register a complaint in this case. If you need any further assistance or have any questions, please don't hesitate to reach out. We're here to help!`;
            }
        } else if (currentFlow === MISBEHAVIOR_BY_SR) {
            if ((shipmentStatus === "Manifestation" || shipmentStatus === "Inscan") && attempts === 0 && getBusinessType() === "forward") {
                prompt = "It looks like your product hasn't been attempted yet. If you have any other concerns, feel free to let us know!";
            } else if (shipmentStatus === "Manifestation" && attempts === 0 && getBusinessType() === "reverse") {
                prompt = "It looks like your product hasn't been pickedup yet. If you have any other concerns, feel free to let us know!";
            } else {
                ticketType = "Open";
            }
        } else if (currentFlow === CHARGED_EXTRA_AMOUNT) {
            if (shipmentStatus === "Delivered") {
                ticketType = "Open";
            } else if (shipmentStatus === "RTO") {
                prompt = `We understand your concern. However, as per our records, this shipment was marked as RTO (Return to Origin). Unfortunately, we are unable to raise a complaint in this case. If you have any further questions, please feel free to reach out. We're here to help!`;
            } else {
                prompt = "The shipment is not delivered yet. If you have any other concerns, feel free to let us know!"
            }
        } else if (currentFlow === WRONG_PRODUCT_PICKED) {
            if (shipmentStatus === "Manifestation") {
                prompt = `The pickup request for Shipment ID ${shippingID} was initiated by ${clientName} on ${delivertDate}. As per our details, the product has not yet been picked. Please contact our Customer Care at 020-49116100 for further assistance. Thank you for your understanding!`;
                // "It looks like your product hasn't been picked yet. If you have any other concerns, feel free to let us know!";
            } 
            else if (shipmentStatus === "PickedUp" || shipmentStatus === "DTO" || shipmentStatus === "OFP") {
                ticketType = "Open";
            }
        } else if (currentFlow === PRODUCT_NOT_PICKED) {
            if (currentButton === "Ok, Kindly pick the shipment quickly." || currentButton === "I do not agree with the reason for non-pickup provided.") {
                return ["Open", ''];
            } else if (currentButton === "Yes, my return shipment is picked.") {
                setIntentValue("111")
                return [ticketType, 'Great!'];
            } else if (currentButton === "No, the shipment is not yet picked.") {
                ticketType = "Open";
                prompt = "We apologize for the inconvenience! Let us look into this on priority.";
            }  else if (currentButton === "No, the shipment is not yet picked.") {
                ticketType = "Open";
            } else if (shipmentStatus === "Manifestation" && attempts >= 1) {
                if (reattemptDate && reattemptDate != '' && reattemptDate != 'None') {
                    prompt = `The pickup request for Shipment ID ${shippingID} was initiated by ${clientName} on ${delivertDate}. We attempted to pick up the product but were unable to proceed due to ${ndrReason} on ${ndrDate}. We will try to pick up the product on ${reattemptDate}. You will be notified via SMS and a phone call once the pickup is scheduled`;
                } else {
                    prompt = `The pickup request for Shipment ID ${shippingID} was initiated by ${clientName} on ${delivertDate}. We attempted to pick up the product but were unable to proceed due to ${ndrReason} on ${ndrDate}. We are currently awaiting further instructions from the client. Once we receive the updated pickup date, we will process the request and ensure the product is picked up as soon as possible.`;
                }
            } else if (shipmentStatus === "OFP") {
                setIntentValue("108")
                prompt = `The pickup request for Shipment ID ${shippingID} was initiated by ${clientName} on ${delivertDate}. Our service representative is currently out for pickup and will contact you shortly. Thank you for your patience!`;
            } else if (shipmentStatus === "Manifestation") {
                setIntentValue("108")
                prompt = `The pickup request for Shipment ID ${shippingID} was initiated by ${clientName} on ${delivertDate}. We will attempt to pick up the product on ${delivertDate}. Thank you for your patience!`;
            } else if (shipmentStatus === "PickedUp") {
                setIntentValue("111")
                prompt = `The pickup request for Shipment ID ${shippingID} was initiated by ${clientName}. We successfully picked up the product on ${delivertDate}, and it will be returned to its origin very soon.`;
            } else if (shipmentStatus === "DTO" && getWHHandOver() === 'true') {
                setIntentValue("111")
                prompt = `We understand your concern. However, as per our records, the product has already been picked up on ${delivertDate} and is delivered to origin. As a result, a complaint cannot be raised in this case. For any queries, please feel free to contact ${clientName} directly. Thank you for your understanding!`;
            } else if (shipmentStatus === "DTO") {
                setIntentValue("111")
                prompt = `We understand your concern. However, as per our records, the product has already been picked up on ${delivertDate} and is on its way to its origin. As a result, a complaint cannot be raised in this case. For any queries, please feel free to contact ${clientName} directly. Thank you for your understanding!`;
            }
        } else if (currentFlow === RPCANCEL_REFUND_DATE_SELECTION || currentFlow === NDR_PNC_DATE_SELECTION) {
            ticketType = "Open";
            if (currentFlow === RPCANCEL_REFUND_DATE_SELECTION) {
                setIntentValue("59");
            }
        } else if (
            currentFlow === NDR_PNC_REATTEMPT_DELAY
            || currentFlow === NDR_CWFD_REATTEMPT_DELAY
            || currentFlow === NDR_CRA_REATTEMPT_DELAY
            || currentFlow === NDR_ADI_REATTEMPT_DELAY
        ) {
            ticketType = "Open";
        } else if (
            currentFlow === NDR_CWFD_CALL_LOG
            || currentFlow === NDR_CRA_CALL_LOG
            || currentFlow === NDR_ADI_CALL_LOG
            || currentFlow === NPR_HANDED_CALL_LOG
            || currentFlow === NPR_ADI_CALL_LOG
            || currentFlow === NPR_CWFP_CALL_LOG
            || currentFlow === RPCANCEL_PICKUP_CALL_LOG
        ) {
            ticketType = "Open";
        } else if (currentFlow === PRODUCT_DAMAGED || currentFlow === PRODUCT_MISSING) {
            if (currentButton === PRODUCT_DAMAGED && shipmentStatus === "Delivered") {
                ticketType = "Open";
                setIntentValue("7")
            } else if (currentButton === PRODUCT_MISSING && shipmentStatus === "Delivered") {
                ticketType = "Open";
                setIntentValue("6")
            } else if (shipmentStatus !== "Delivered" && shipmentStatus !== "RTO") {
                setIntentValue("108");
                prompt = "We noticed that your product has not yet been delivered. Once the delivery is complete, please feel free to raise a complaint if you face any issues. Thank you for your understanding!";
            } else if (shipmentStatus === "RTO" && getWHHandOver() === 'true') {
                prompt = `We understand your concern and truly appreciate you reaching out. As per our records, this shipment was marked as RTO (Return to Origin) and has been returned to the vendor, so we're unable to register a complaint in this case. If you need any further assistance or have any questions, please don't hesitate to reach out. We're here to help!`;
            } else if (shipmentStatus === "RTO") {
                prompt = `We understand your concern and truly appreciate you reaching out. As per our records, this shipment was marked as RTO (Return to Origin), so we're unable to register a complaint in this case. If you need any further assistance or have any questions, please don't hesitate to reach out. We're here to help!`;
            }
        } else if (
            getIntentValue() === '135'
            || currentFlow === DELIVERED_INCORRECT_SHIPMENT_FLOW
            || (currentButton && String(currentButton).toLowerCase().includes('incorrect shipment'))
        ) {
            return ['Open', ''];
        }
        return [ticketType, prompt];
    } catch (error) {
        console.error('Error sending webhook data:', error);
        return [];
    }
}